import {
    BackendClient,
    type BackendClientParameters,
    type Defineable,
} from "@internal/backstage-plugin-utility-common";

import { type PromptResult } from "./types";

export type { AskjackApi, Message, PromptResult } from "./types";

// ── Client ─────────────────────────────────────────────────────────────────────

/** Options for creating an {@link AskjackClient}. */
export type AskjackClientOptions = Omit<
    BackendClientParameters,
    "targetPluginId"
>;

/**
 * Frontend client for the AskJack backend plugin.
 *
 * Extends {@link BackendClient} to get built-in auth, discovery, and error
 * handling. Instantiate via the {@link AskjackRef} API factory in the app.
 */
export class AskjackClient extends BackendClient {
    constructor(options: AskjackClientOptions) {
        super({ ...options, targetPluginId: "askjack" });
    }

    async prompt(
        prompt: string,
        conversationId: Defineable<string>
    ): Promise<PromptResult> {
        try {
            const resp = await this.api<PromptResult>("/prompt", {
                method: "POST",
                body: JSON.stringify({
                    prompt: btoa(prompt),
                    conversationId,
                }),
            });

            if (!resp.body.ok) {
                throw new Error(resp.body.error);
            }

            return resp.body.data;
        } catch (e: unknown) {
            if (e instanceof Error) throw e;
            throw new Error("Unexpected error communicating with AskJack");
        }
    }
}
